import React from 'react'
import { useField } from 'formik'
import useTitleAndError from 'fields/useTitleAndError/useTitleAndError'
import { Upload } from 'antd'
import { UploadProps } from 'antd/lib/upload'
import { checkFileLimit } from 'utils'

export type FUploadProps = Partial<UploadProps> & {
  title?: string
  children?: React.ReactNode
  fullWidth?: boolean
}

function FUpload(props: FUploadProps) {
  const [field, , helpers] = useField(props as any) // [valueField, valueMeta, valueHelpers]
  const [title, error] = useTitleAndError(props)
  const { multiple, fullWidth = false } = props

  return (
    <React.Fragment>
      {title}
      <Upload
        onRemove={(file) => {
          const index = field.value.indexOf(file)
          const newFileList = field.value.slice()
          newFileList.splice(index, 1)
          helpers.setValue(newFileList)
        }}
        beforeUpload={(file, fileList) => {
          const isFileLimitExceed = checkFileLimit(file)
          if (isFileLimitExceed) return false

          if (multiple) {
            helpers.setValue([...field.value, ...fileList])
            return false
          }
          helpers.setValue([file])
          return false
        }}
        fileList={field.value}
        multiple={multiple}
        {...props}
      />
      {error}
      <style jsx global>
        {`
          .ant-upload {
            width: ${fullWidth ? '100%' : 'auto'};
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default FUpload
